  /* eslint-disable jsx-a11y/anchor-is-valid */
  import React, { useEffect, useRef, useState } from "react";
  import { Button } from "react-bootstrap";
  import { useAudio } from "../Contexts/AudiosContext";
  import AudioPlayer from "../Services/AudioPlayer";
  import closeimg from "../Images/close-C.png";
  import songplay from "../Images/songPlay.svg";
  import pause from "../Images/pause.svg";
  import mni from "../Images/minimize-C.png";
  import AudioLyrics from "../Components/AudioLyrics";
  import i18n, { _get_i18Lang } from "../i18n";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import { AudioInfoDialog } from "../Pages/AudioInfoDialog";

  const AudioPlayerPage = ({ match }: any) => {
    const navigate = useNavigate();
    const { slug: routeSlug } = useParams<{ slug?: string; cat?: string }>();
    const {
      setAudiosList,
      setIsMinismise,
      audiosList,
      playAudio,
      currentAudio,
      audioInfoDialog,
      close,
      showList,
      setShowList,
    } = useAudio();

    const location: any = useLocation();
    // const state = (location.state as {
    //   audioId?: string;
    //   audioslug?: string;
    //   sl?: string;
    //   sorting?: string;
    //   index?: number;
    //   audiocat?: string;
    // }) || {};

    const state = (location.state as {
    audioId?: string;
    pravachanId?: string;
    audioslug?: string;
    pravachanSlug?: string;
    sl?: string;
    sorting?: string;
    index?: number;
    audiocat?: string;
  }) || {};

    const catId = useRef<string | any>(state?.audiocat || "");
    const auid = useRef<string | undefined>(state?.audioId || "");
    const [hide, setHide] = React.useState(false);

    const [cardWidth, setcardWidth] = useState(window.innerWidth);
    // window.addEventListener("resize", () => {
    //   setcardWidth(window.innerWidth);
    // });

    useEffect(() => {
  const handleResize = () => {
    setcardWidth(window.innerWidth);
  };

  window.addEventListener("resize", handleResize);

  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);
  
  const id =
    location.state?.pravachanId ||
    location.state?.audioId;

    // const [Type, setType] = React.useState<any | undefined>(() => {
    //   const fromPath = window.location.pathname.startsWith("/pravachans/")
    //     ? "pravachans"
    //     : "audios";
    //   return localStorage.getItem("type") || fromPath;
    // });
    const getTypeFromPath = () => {
      const pathname = window.location.pathname;

      if (pathname.startsWith("/pravachans/")) {
        return "pravachans";
      }

      return "audios";
    };

    const [Type, setType] = React.useState<string>(getTypeFromPath());
 
    useEffect(() => {
      const nextType = window.location.pathname.startsWith("/pravachans/")
        ? "pravachans"
        : "audios";

      localStorage.setItem("type", nextType);
      setType(nextType);
    }, [location.pathname]);

    // useEffect(() => {
    //   const nextType = window.location.pathname.startsWith("/pravachans/")
    //     ? "pravachans"
    //     : "audios";
    //   localStorage.setItem("type", nextType);
    //   setType(nextType);
    // }, [location.pathname]);

    // useEffect(() => {
    //   // const routeType = Type || localStorage.getItem("type") || "audios";
    //   const routeType = window.location.pathname.startsWith("/pravachans/")
    //   ? "pravachans"
    //   : "audios";
    //   const normalizedSlug = decodeURIComponent(
    //     routeSlug ||
    //     state?.pravachanSlug ||
    //     state?.audioslug ||
    //     state?.sl ||
    //     ""
    //   );

    //   const directId = state?.pravachanId || state?.audioId || "";

    //   if (!normalizedSlug && !directId) {
    //     return;
    //   }

    //   const resolveAudio = async () => {
    //     // Try to restore last list from sessionStorage (saved when user clicked
    //     // from the list page). This keeps the sidebar populated when opening
    //     // the player URL in a new tab.
    //     try {
    //       const raw = sessionStorage.getItem("lastPravachansList");
    //       if (raw) {
    //         const payload = JSON.parse(raw);
    //         if (Array.isArray(payload.items) && payload.items.length > 0 && routeType === "pravachans") {
    //           setAudiosList(payload.items);
    //         }
    //       }
    //     } catch (e) {
    //       // ignore
    //     }
    //     try {
    //       const res = await AudioPlayer.getAudioPlayer(
    //         _get_i18Lang(),
    //         0,
    //         // 1000,
    //         12,
    //         false,
    //         state?.audiocat || "",
    //         "",
    //         "",
    //         state?.sorting || "",
    //         "",
    //         false,
    //         routeType
    //       );

    //       let items: any[] = [];
    //       if (res?.status && Array.isArray(res.result?.items)) {
    //         items = res.result.items;
    //       }
    //           const selectedId = state?.pravachanId || state?.audioId || "";

    //       // const selectedAudio =
    //       //   items.find(
    //       //     (item: any) =>
    //       //       selectedId &&
    //       //       String(item.id) === String(selectedId)
    //       //   ) ||
    //       //   items.find(
    //       //     (item: any) =>
    //       //       normalizedSlug &&
    //       //       item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
    //       //   );

    //       // const selectedAudio =
    //       // items.find(
    //       //   (item: any) =>
    //       //     selectedId &&
    //       //     String(item.id) === String(selectedId)
    //       // ) ||
    //       // items.find(
    //       //   (item: any) =>
    //       //     normalizedSlug &&
    //       //     item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
    //       // );
    //       //     console.log("PATH =", window.location.pathname); 
    //       //   items.find((item: any) => String(item.id) === String(state?.audioId)) ||
    //       //   items.find((item: any) => item.slug === normalizedSlug) ||
    //       //   items.find((item: any) => item.slug === decodeURIComponent(normalizedSlug));
    //       // const selectedAudio =
    //   //   items.find(
    //   //     (item: any) =>
    //   //       selectedId &&
    //   //       String(item.id) === String(selectedId)
    //   //   ) ||
    //   //   items.find(
    //   //     (item: any) =>
    //   //       normalizedSlug &&
    //   //       item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
    //   //   );

    //   // console.log("PATH =", window.location.pathname);

    //   // items.find((item: any) => String(item.id) === String(state?.audioId)) ||
    //   // items.find((item: any) => item.slug === normalizedSlug) ||
    //   // items.find((item: any) => item.slug === decodeURIComponent(normalizedSlug));


    //   const selectedAudio =
    //   items.find(
    //     (item: any) =>
    //       selectedId &&
    //       String(item.id) === String(selectedId)
    //   ) ||
    //   items.find(
    //     (item: any) =>
    //       normalizedSlug &&
    //       item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
    //   );

    //   console.log("PATH =", window.location.pathname);

    //       if (selectedAudio) {
    //         setIsMinismise(false);
    //         setAudiosList(items);

    //         const index = items.findIndex((item: any) => item.id === selectedAudio.id);
    //         if (index >= 0) {
    //           playAudio(selectedAudio.id, index);
    //           const element = document.getElementById(selectedAudio.id);
    //           element?.scrollIntoView();
    //         }
    //         return;
    //       }
          
    //       if (!selectedAudio && normalizedSlug) {
    //         try {
    //           // First try fetching by id/slug endpoint (may work if backend supports slug lookup)
    //           const slugRes = await AudioPlayer.getAudiosById(normalizedSlug, routeType);
    //           const slugAudio = slugRes?.result || (slugRes?.result?.items && slugRes.result.items[0]) || null;

    //           if (slugAudio) {
    //             // Try to fetch the full list so the sidebar remains populated.
    //             try {
    //               const fullRes = await AudioPlayer.getAudioPlayer(
    //                 _get_i18Lang(),
    //                 0,
    //                 // 1000,
    //                 12,
    //                 false,
    //                 state?.audiocat || "",
    //                 "",
    //                 "",
    //                 state?.sorting || "",
    //                 "",
    //                 false,
    //                 routeType
    //               );

    //               const fullItems = fullRes?.result?.items || [];

    //               if (fullItems.length) {
    //                 setAudiosList(fullItems);
    //                 const idx = fullItems.findIndex((it: any) => String(it.id) === String(slugAudio.id) || (it.slug && it.slug.toLowerCase() === normalizedSlug.toLowerCase()));
    //                 const playIndex = idx >= 0 ? idx : 0;
    //                 const fallbackSegment = fullItems[playIndex]?.slug || fullItems[playIndex]?.id || slugAudio.slug || slugAudio.id;
    //                 const fallbackPath = `/${routeType}/${fallbackSegment}`;
    //                 if (window.location.pathname !== fallbackPath) {
    //                   navigate(fallbackPath, { replace: true });
    //                 }
    //                 playAudio(fullItems[playIndex].id, playIndex);
    //                 return;
    //               }

    //               // If no full list available, fall back to single-item list
    //               setAudiosList([slugAudio]);
    //               const fallbackSegment = slugAudio.slug || slugAudio.id;
    //               const fallbackPath = `/${routeType}/${fallbackSegment}`;
    //               if (window.location.pathname !== fallbackPath) {
    //                 navigate(fallbackPath, { replace: true });
    //               }
    //               playAudio(slugAudio.id, 0);
    //               return;
    //             } catch (err) {
    //               console.error("Error fetching full list for slug fallback:", err);
    //             }
    //           }

    //           // If direct fetch failed (API doesn't resolve slug), try a search-based lookup
    //           const searchRes = await AudioPlayer.getAudioPlayer(
    //             _get_i18Lang(),
    //             0,
    //             // 100,
    //             12,
    //             false,
    //             state?.audiocat || "",
    //             "",
    //             normalizedSlug,
    //             state?.sorting || "",
    //             "",
    //             false,
    //             routeType
    //           );

    //           const searchItems = searchRes?.result?.items || [];
    //           const foundBySearch = searchItems.find((it: any) => it.slug?.toLowerCase() === normalizedSlug.toLowerCase()) || searchItems[0] || null;

    //           if (foundBySearch) {
    //             setAudiosList(searchItems);
    //             const fallbackSegment = foundBySearch.slug || foundBySearch.id;
    //             const fallbackPath = `/${routeType}/${fallbackSegment}`;
    //             if (window.location.pathname !== fallbackPath) {
    //               navigate(fallbackPath, { replace: true });
    //             }
    //             playAudio(foundBySearch.id, 0);
    //             return;
    //           }
    //         } catch (err) {
    //           console.error("Error fetching audio by slug/search fallback:", err);
    //         }
    //       }

    //       const directId = state?.pravachanId || state?.audioId || "";

    //       if (directId) {
    //         const directRes = await AudioPlayer.getAudiosById(directId, routeType);
    //         const directAudio = directRes?.result || directRes?.result?.items?.[0] || null;

    //         if (directAudio) {
    //           setAudiosList([directAudio]);
    //           const fallbackSegment = directAudio.slug || directId;
    //           const fallbackPath = `/${routeType}/${fallbackSegment}`;
    //           if (window.location.pathname !== fallbackPath) {
    //             navigate(fallbackPath, { replace: true });
    //           }
    //           playAudio(directAudio.id, 0);
    //           return;
    //         }
    //       }

    //     } catch (error) {
    //       console.error("Audio route resolution error:", error);
    //     }
    //   };

    //   resolveAudio();

    // }, [Type, routeSlug, id, state?.audioslug, state?.sorting, state?.audiocat, i18n.language]);

// useEffect(() => {
//   const routeType = window.location.pathname.startsWith("/pravachans/")
//     ? "pravachans"
//     : "audios";

//   const normalizedSlug = decodeURIComponent(
//     routeSlug || state?.pravachanSlug || state?.audioslug || state?.sl || ""
//   );

//   const directId = state?.pravachanId || state?.audioId || "";

//   if (!normalizedSlug && !directId) {
//     return;
//   }

//   const resolveAudio = async () => {
//     try {
//       // 1. First check Session Storage
//       const raw = sessionStorage.getItem("lastPravachansList");

//       if (raw && routeType === "pravachans") {
//         const payload = JSON.parse(raw);

//         if (Array.isArray(payload.items) && payload.items.length > 0) {
//           setAudiosList(payload.items);

//           const selectedId = state?.pravachanId || state?.audioId || "";

//           const selectedItem =
//             payload.items.find(
//               (item: any) =>
//                 selectedId && String(item.id) === String(selectedId)
//             ) ||
//             payload.items.find(
//               (item: any) =>
//                 normalizedSlug &&
//                 item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
//             );

//           if (selectedItem) {
//             const index = payload.items.findIndex(
//               (item: any) => String(item.id) === String(selectedItem.id)
//             );

//             setIsMinismise(false);
//             playAudio(selectedItem.id, index);

//             // setTimeout(() => {
//             //   document
//             //     .getElementById(selectedItem.id)
//             //     .scrollIntoView({ behavior: "smooth", block: "center" });
//             // }, 100);

//             setTimeout(() => {
//               document
//                 .getElementById(selectedItem.id)
//                 ?.scrollIntoView({ behavior: "smooth", block: "center" });
//             }, 100);
//             return; // Successful resolution from SessionStorage
//           }
//         }
//       }

//       // 2. Fallback: Fetch complete list from API if SessionStorage fails or is empty
//       const res = await AudioPlayer.getAudioPlayer(
//         _get_i18Lang(),
//         0,
//         12, // 12 items sidebar me render honge
//         false,
//         state?.audiocat || "",
//         "",
//         "",
//         state?.sorting || "",
//         "",
//         false,
//         routeType
//       );

//       if (res?.status && Array.isArray(res.result?.items)) {
//         const items = res.result.items;
//         setAudiosList(items);

//         const selectedId = state?.pravachanId || state?.audioId || "";

//         const selectedAudio =
//           items.find(
//             (item: any) =>
//               selectedId && String(item.id) === String(selectedId)
//           ) ||
//           items.find(
//             (item: any) =>
//               normalizedSlug &&
//               item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
//           );

//         if (selectedAudio) {
//           const index = items.findIndex(
//             (item: any) => String(item.id) === String(selectedAudio.id)
//           );
//           setIsMinismise(false);
//           playAudio(selectedAudio.id, index >= 0 ? index : 0);

//           setTimeout(() => {
//             document
//               .getElementById(selectedAudio.id)
//               ?.scrollIntoView({ behavior: "smooth", block: "center" });
//           }, 100);
//         }
//       }
//     } catch (error) {
//       console.error("Error resolving pravachan/audio list:", error);
//     }
//   };

//   resolveAudio();
// }, [
//   Type,
//   routeSlug,
//   id,
//   state?.audioslug,
//   state?.sorting,
//   state?.audiocat,
//   i18n.language,
// ]);
// useEffect(() => {
//   const routeType = window.location.pathname.startsWith("/pravachans/")
//     ? "pravachans"
//     : "audios";

//   const normalizedSlug = decodeURIComponent(
//     routeSlug || state?.pravachanSlug || state?.audioslug || state?.sl || ""
//   );

//   const selectedId = state?.pravachanId || state?.audioId || "";

//   if (!normalizedSlug && !selectedId) {
//     return;
//   }

//   const resolveAudio = async () => {
//     try {
//       // 1. First check SessionStorage for cached list (Pagination/List click case)
//       const raw = sessionStorage.getItem("lastPravachansList");
//       if (raw && routeType === "pravachans") {
//         const payload = JSON.parse(raw);
//         if (Array.isArray(payload.items) && payload.items.length > 0) {
//           const selectedItem =
//             payload.items.find(
//               (item: any) =>
//                 selectedId && String(item.id) === String(selectedId)
//             ) ||
//             payload.items.find(
//               (item: any) =>
//                 normalizedSlug &&
//                 item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
//             );

//           // Agar clicked item pagination list me mil jata hai
//           if (selectedItem) {
//             setAudiosList(payload.items);
//             const index = payload.items.findIndex(
//               (item: any) => String(item.id) === String(selectedItem.id)
//             );

//             setIsMinismise(false);
//             playAudio(selectedItem.id, index >= 0 ? index : 0);

//             setTimeout(() => {
//               const el = document.getElementById(selectedItem.id);
//               el?.scrollIntoView({ behavior: "smooth", block: "center" });
//             }, 100);

//             return;
//           }
//         }
//       }

//       // 2. Direct Slug/ID API Fetch (If direct URL access, reload, or item not found in sessionStorage)
//       let directAudio: any = null;
//       try {
//         const lookupKey = selectedId || normalizedSlug;
//         const directRes = await AudioPlayer.getAudiosById(lookupKey, routeType);
//         directAudio = directRes?.result || directRes?.result?.items?.[0] || null;
//       } catch (e) {
//         console.error("Direct fetch failed, falling back to player list", e);
//       }

//       // 3. Dynamic Category/Sorting Fetch based on current item details
//       const categoryId = directAudio?.categoryId || state?.audiocat || "";
//       const sortOption = state?.sorting || "";

//       const res = await AudioPlayer.getAudioPlayer(
//         _get_i18Lang(),
//         0,
//         12,
//         false,
//         categoryId,
//         "",
//         "",
//         sortOption,
//         "",
//         false,
//         routeType
//       );

//       if (res?.status && Array.isArray(res.result?.items)) {
//         let items = res.result.items;

//         // Ensure active item exists in sidebar list even if offset changes
//         if (
//           directAudio &&
//           !items.some((it: any) => String(it.id) === String(directAudio.id))
//         ) {
//           items = [directAudio, ...items.slice(0, 11)];
//         }

//         setAudiosList(items);

//         const targetAudio =
//           items.find(
//             (item: any) =>
//               (selectedId && String(item.id) === String(selectedId)) ||
//               (normalizedSlug &&
//                 item.slug?.toLowerCase() === normalizedSlug.toLowerCase())
//           ) || directAudio || items[0];

//         if (targetAudio) {
//           const idx = items.findIndex(
//             (item: any) => String(item.id) === String(targetAudio.id)
//           );

//           setIsMinismise(false);
//           playAudio(targetAudio.id, idx >= 0 ? idx : 0);

//           setTimeout(() => {
//             const el = document.getElementById(targetAudio.id);
//             el?.scrollIntoView({ behavior: "smooth", block: "center" });
//           }, 100);
//         }
//       }
//     } catch (error) {
//       console.error("Error resolving pravachan/audio list:", error);
//     }
//   };

//   resolveAudio();
// }, [
//   location.key, // Essential for handling pagination and route navigation triggers
//   Type,
//   routeSlug,
//   state?.pravachanId,
//   state?.audioId,
//   state?.pravachanSlug,
//   state?.audioslug,
//   state?.sorting,
//   state?.audiocat,
//   i18n.language,
// ]);
useEffect(() => {
  const routeType = window.location.pathname.startsWith("/pravachans/")
    ? "pravachans"
    : "audios";

  const normalizedSlug = decodeURIComponent(
    routeSlug || state?.pravachanSlug || state?.audioslug || state?.sl || ""
  );

  const selectedId = state?.pravachanId || state?.audioId || "";

  if (!normalizedSlug && !selectedId) {
    return;
  }

  // Helper function to maintain list sorting
  const applySorting = (items: any[]) => {
    if (!Array.isArray(items)) return [];
    const sorted = [...items];
    const sortType = state?.sorting;

    if (sortType === "a-z" || sortType === "asc") {
      return sorted.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    } else if (sortType === "z-a" || sortType === "desc") {
      return sorted.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    }
    return sorted;
  };

  const resolveAudio = async () => {
    try {
      // 1. Session Storage check
      const raw = sessionStorage.getItem("lastPravachansList");
      if (raw && routeType === "pravachans") {
        const payload = JSON.parse(raw);
        if (Array.isArray(payload.items) && payload.items.length > 0) {
          const sortedList = applySorting(payload.items);

          const selectedItem =
            sortedList.find(
              (item: any) =>
                selectedId && String(item.id) === String(selectedId)
            ) ||
            sortedList.find(
              (item: any) =>
                normalizedSlug &&
                item.slug?.toLowerCase() === normalizedSlug.toLowerCase()
            );

          if (selectedItem) {
            setAudiosList(sortedList);
            const index = sortedList.findIndex(
              (item: any) => String(item.id) === String(selectedItem.id)
            );

            setIsMinismise(false);
            playAudio(selectedItem.id, index >= 0 ? index : 0);

            setTimeout(() => {
              const el = document.getElementById(selectedItem.id);
              el?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 100);

            return;
          }
        }
      }

      // 2. Direct lookup if not in storage
      let directAudio: any = null;
      try {
        const lookupKey = selectedId || normalizedSlug;
        const directRes = await AudioPlayer.getAudiosById(lookupKey, routeType);
        directAudio = directRes?.result || directRes?.result?.items?.[0] || null;
      } catch (e) {
        console.error("Direct fetch failed:", e);
      }

      // 3. API Fetch with Sorting Parameter
      const categoryId = directAudio?.categoryId || state?.audiocat || "";
      const sortOption = state?.sorting || "";

      const res = await AudioPlayer.getAudioPlayer(
        _get_i18Lang(),
        0,
        12,
        false,
        categoryId,
        "",
        "",
        sortOption,
        "",
        false,
        routeType
      );

      if (res?.status && Array.isArray(res.result?.items)) {
        let items = applySorting(res.result.items);

        if (
          directAudio &&
          !items.some((it: any) => String(it.id) === String(directAudio.id))
        ) {
          items = [directAudio, ...items.slice(0, 11)];
        }

        setAudiosList(items);

        const targetAudio =
          items.find(
            (item: any) =>
              (selectedId && String(item.id) === String(selectedId)) ||
              (normalizedSlug &&
                item.slug?.toLowerCase() === normalizedSlug.toLowerCase())
          ) || directAudio || items[0];

        if (targetAudio) {
          const idx = items.findIndex(
            (item: any) => String(item.id) === String(targetAudio.id)
          );

          setIsMinismise(false);
          playAudio(targetAudio.id, idx >= 0 ? idx : 0);

          setTimeout(() => {
            const el = document.getElementById(targetAudio.id);
            el?.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 100);
        }
      }
    } catch (error) {
      console.error("Error resolving audio:", error);
    }
  };

  resolveAudio();
}, [
  location.key,
  Type,
  routeSlug,
  state?.pravachanId,
  state?.audioId,
  state?.pravachanSlug,
  state?.audioslug,
  state?.sorting,
  state?.audiocat,
  i18n.language,
]);
    return (
      <div className="uyutuy">
        <div
          className="row"
          style={{
            borderBottomColor: "black",
            marginRight: "0px",
          }}
        >
          {!showList && (
            <div
              style={{
                textAlign: "center",
                zIndex: 3,
                position: "absolute",
                width: "50%",
                border: "none",
                marginTop: "15%",
                display: cardWidth > 768 ? "none" : "block",
              }}
            >
              <div className="songSidebar" style={{ widows: "137%" }}>
                <div className="songCategoriesmobilesize">
                  {audiosList.map((a, i) => (
                    <div key={a?.id}>
                      <div
                        id={a?.id}
                        style={{
                          height: "75px",
                          cursor: "pointer",
                          borderBottom: "1px solid #ebe8dd",
                          paddingTop: "15px",
                        }}
                      >
                        {a.id === currentAudio?.id ? (
                          <img
                            alt=""
                            title="play"
                            style={{ width: "51px", height: "49px" }}
                            src={songplay}
                            // onClick={() => {
                            //   playAudio(a.id, i);
                            // }}
                            onClick={() => {
                        const currentIndex = audiosList.findIndex((item: any) => String(item.id) === String(a.id));
                        playAudio(a.id, currentIndex >= 0 ? currentIndex : i);
                      }}
                          ></img>
                        ) : (
                          <img
                            alt=""
                            title="pause"
                            style={{ width: "51px", height: "49px" }}
                            src={pause}
                            onClick={() => {
                              // playAudio(a.id, i);
                             const currentIndex = audiosList.findIndex((item: any) => String(item.id) === String(a.id));
                            playAudio(a.id, currentIndex >= 0 ? currentIndex : i);
                            }}
                          ></img>
                        )}

                        <Button
                          style={{
                            color: "#212529",
                            backgroundColor: "white",
                            borderColor: "white",
                            paddingTop: "0px",
                          }}
                          variant={a.id === currentAudio?.id ? "link" : "light"}
                          onClick={() => {
                            // playAudio(a.id, i);
                              const currentIndex = audiosList.findIndex((item: any) => String(item.id) === String(a.id));
                          playAudio(a.id, currentIndex >= 0 ? currentIndex : i);
                          }}
                        >
                          {a.name != null && a.name.length > 15
                            ? a.name.slice(0, 15) + "..."
                            : a.name}
                        </Button>
                      </div>
                    </div>
                  ))}
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          )}
          <div
            className={cardWidth > 768 ? "col-3" : "col-lg-3"}
            style={{ display: cardWidth > 768 ? "block" : "none" }}
          >
            <div className="songSidebar">
              <div className="songCategories">
                {audiosList.map((a, i) => (
                  <div key={a?.id}>
                    <div
                      id={a?.id}
                      style={{
                        height: "75px",
                        cursor: "pointer",
                        borderBottom: "1px solid #ebe8dd",
                        paddingTop: "15px",
                        width: "280px"
                      }}
                    >
                      {a.id === currentAudio?.id ? (
                        <img
                          alt=""
                          title="play"
                          style={{ width: "51px", height: "49px" }}
                          src={songplay}
                          onClick={() => {
                            playAudio(a.id, i);
                          }}
                        ></img>
                      ) : (
                        <img
                          alt=""
                          title="pause"
                          style={{ width: "51px", height: "49px" }}
                          src={pause}
                          onClick={() => {
                            playAudio(a.id, i);
                          }}
                        />
                      )}

                      <Button
                        style={{
                          color: "#212529",
                          backgroundColor: "white",
                          borderColor: "white",
                          paddingTop: "0px",
                          fontFamily: 'ChanakyaUni',
                          fontSize: '22px'
                        }}
                        variant={a.id === currentAudio?.id ? "link" : "light"}
                        onClick={() => {
                          playAudio(a.id, i);
                        }}
                      >
                        {a.name != null && a.name.length > 24
                          ? a.name.slice(0, 24) + "..."
                          : a.name}
                      </Button>
                    </div>
                  </div>
                ))}
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>

          <div className={cardWidth > 768 ? "col-9 no-copy" : "col-lg-9 no-copy"}>
            <div className="closeTab">
              <a>
                <img
                  alt=""
                  src={mni}
                  style={{ marginLeft: "10px" }}
                  className="pe-sm-2"
                  onClick={() => {
                    setIsMinismise(true);
                    navigate(`/${Type}/`);
                  }}
                ></img>
              </a>

              <a>
                {/* <img
                  // style={{marginLeft:'10px'}}
                  alt=""
                  src={closeimg}
                  onClick={() => {
                    setHide(true);
                    close();
                    const ret = location.state && (location.state as any).returnTo;
                    const isValidString = typeof ret === 'string' && ret.trim() !== '' && ret !== 'undefined' && ret !== 'null';
                    if (isValidString) {
                      navigate(ret);
                    } else {
                      // Fallback: use last search path saved in sessionStorage (if any)
                      let lastSearch: any = null;
                      try {
                        lastSearch = sessionStorage.getItem('lastSearchReturnTo');
                      } catch (e) {}
                      const isLastSearchValid = typeof lastSearch === 'string' && lastSearch.trim() !== '' && lastSearch !== 'undefined' && lastSearch !== 'null';
                      if (isLastSearchValid) {
                        navigate(lastSearch);
                      } else {
                        navigate("/audios");
                      }
                    }
                  }}
                /> */}

                {/* <img
                  // style={{marginLeft:'10px'}}
                  alt=""
                  src={closeimg}
                  onClick={() => {
                    setHide(true);
                    close();
                    const ret = location.state && (location.state as any).returnTo;
                    const isValidString = typeof ret === 'string' && ret.trim() !== '' && ret !== 'undefined' && ret !== 'null';
                    if (isValidString) {
                      navigate(ret);
                    } else {
                      // Fallback: use last search path saved in sessionStorage (if any)
                      let lastSearch: any = null;
                      try {
                        lastSearch = sessionStorage.getItem('lastSearchReturnTo');
                      } catch (e) {}
                      const isLastSearchValid = typeof lastSearch === 'string' && lastSearch.trim() !== '' && lastSearch !== 'undefined' && lastSearch !== 'null';
                      if (isLastSearchValid) {
                        navigate(lastSearch);
                      } else {
                        navigate("/audios");
                      }
                    }
                  }}
                /> */}


                {/* <img
                  alt=""
                  src={closeimg}
                  onClick={() => {
                    setHide(true);
                    close();

                    const returnTo = location.state?.returnTo;

                    if (
                      typeof returnTo === "string" &&
                      returnTo.trim() !== ""
                    ) {
                      // Search result se aaya hai
                      navigate(returnTo);
                    } else {
                      // Normal audio list ya direct URL se aaya hai
                      navigate("/audios");
                    }
                  }}
                /> */}


     {/* <img
  alt=""
  src={closeimg}
  onClick={() => {
    setHide(true);
    close();

    const returnTo = location.state?.returnTo;

    if (
      typeof returnTo === "string" &&
      returnTo.trim() !== ""
    ) {
      // Search result se aaya hai
      navigate(returnTo);
    } else {
      // Pravachan hai toh /pravachans par, audio hai toh /audios par jaayega
      navigate(`/${Type}`);
    }
  }}
/>  */}


{/* <img
  alt=""
  src={closeimg}
  onClick={() => {
    setHide(true);
    close();

    const returnTo = location.state?.returnTo;

    if (typeof returnTo === "string" && returnTo.trim() !== "") {
      navigate(returnTo);
    } else {
      navigate(`/${Type}`);
    }
  }}
/> */}
  {/* <img
    alt=""
    src={closeimg}
    onClick={() => {
      setHide(true);
      close();

      const returnTo = location.state?.returnTo;


      
      if (typeof returnTo === "string" && returnTo.trim() !== "") {
        navigate(returnTo);
      } else if (location.state?.returnTo) {
        navigate("/");
      } else {
        navigate(`/${Type}`);
      }
    }}
  /> */}

  <img
  alt=""
  src={closeimg}
  onClick={() => {
    setHide(true);
    close();

    const returnTo = location.state?.returnTo;

    if (typeof returnTo === "string" && returnTo.trim() !== "") {
      navigate(returnTo);
    } else {
      navigate(`/${Type}`);
    }
  }}
/>

{/* <img
  alt=""
  src={closeimg}
  onClick={() => {
    setHide(true);
    close();

    const returnTo = location.state?.returnTo;

    if (typeof returnTo === "string" && returnTo.trim() !== "") {
      navigate(returnTo);
    } else {
      // Agar returnTo nahi hai, browser history mein previous page par jao
      navigate(-1);
    }
  }}
/> */}


              </a>
            </div>
            <AudioLyrics />
            {currentAudio?.id ? (
              <AudioInfoDialog showModal={audioInfoDialog} />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  };
  export default AudioPlayerPage;

